import { createContext, FC, ReactNode, useReducer } from "react";
import PropTypes from "prop-types";
interface State {
    isLoading: boolean;
    isLoadingChild:boolean;
}
interface LoadingContextvalue extends State {
    Showloading: (Action?:string) => void;
    Hideloading: (Action?:string) => void;
}
interface LoadingProviderProp {
    children: ReactNode;
}
type InitializeAction = {
    type: "INITIALIZE";
    payload: {
        isLoading: boolean;
    };
};
type ShowloadingAction = {
    type: "SHOW";
    payload: {
        isLoading: boolean;
        isLoadingChild:boolean;
    };
};
type HideloadingAction = {
    type: "HIDE";
    payload: {
        isLoading: boolean;
        isLoadingChild:boolean;

    };
};
type Action = InitializeAction | ShowloadingAction | HideloadingAction;

const initialState: State = {
    isLoading: true,
    isLoadingChild:false,
};
const handlers: Record<string, (state: State, action: Action) => State> = {
    INITIALIZE: (state: State, action: InitializeAction): State => {
        const { isLoading } = action.payload;
        return {
            ...state,
            isLoading,
        };
    },        
    SHOW: (state: State, action: ShowloadingAction): State => {
        const { isLoading,isLoadingChild } = action.payload;

        return {
            ...state,
            isLoading,
            isLoadingChild
        };            
    },
    HIDE: (state: State, action: HideloadingAction): State => {
        const { isLoading,isLoadingChild } = action.payload;

        return {
            ...state,
            isLoading,
            isLoadingChild
        };
    },
};

const reducer = (state: State, action: Action): State =>
    handlers[action.type] ? handlers[action.type](state, action) : state;

const LoadingContext = createContext<LoadingContextvalue>({
    ...initialState,
    Showloading: (Action?) => {},
    Hideloading: (Action?) => {},
});

export const LoadingProvider: FC<LoadingProviderProp> = (props) => {
    // debugger;
    const { children } = props;
    const [state, dispatch] = useReducer(reducer, initialState);

    const Showloading = (Action): void => {
        if(Action=="LOADINGCHILD"){
            dispatch({
                type: "SHOW",
                payload: {
                    isLoading: false,
                    isLoadingChild:true
                },
            });
        }else{
            dispatch({
                type: "SHOW",
                payload: {
                    isLoading: true,
                    isLoadingChild:false
                },
            });
        }
       
    };

    const Hideloading = (Action): void => {
        if(Action=="LOADINGCHILD"){
            dispatch({
                type: "HIDE",
                payload: {
                    isLoading: true,
                    isLoadingChild:false,
                },
            });
        }else{
            dispatch({
                type: "HIDE",
                payload: {
                    isLoading: false,
                    isLoadingChild:true,
                },
            });
        }
       
    };
    return (
        <LoadingContext.Provider
            value={{
                ...state,
                Showloading,
                Hideloading,
            }}
        >
            {children}
        </LoadingContext.Provider>
    );
};

LoadingProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
export default LoadingContext;
